import { useState, useEffect } from 'react';

interface Props {
  job?: any | null;
  onClose: () => void;
  onSave: (data: any) => void;
}

export default function JobFormModal({ job, onClose, onSave }: Props) {
  const [form, setForm] = useState({
    title: '', company: '', location: '', type: 'full-time', status: 'open',
    description: '', requirements: [] as string[], posted_date: '',
  });

  useEffect(() => {
    if (job) {
      setForm({
        title: job.title, company: job.company, location: job.location,
        type: job.type, status: job.status, description: job.description || '',
        requirements: job.requirements || [], posted_date: job.posted_date || '',
      });
    }
  }, [job]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => { e.preventDefault(); onSave(form); };

  const inputClass = "w-full px-4 py-2.5 text-sm rounded-xl border-2 border-rose-100 bg-rose-50/30 focus:outline-none focus:border-rose-300 transition-all";
  const labelClass = "block text-xs font-semibold text-gray-600 mb-1.5";

  return (
    <div className="fixed inset-0 bg-black/20 z-50 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-2xl border-2 border-rose-100 w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b-2 border-rose-100 sticky top-0 bg-white z-10">
          <h2 className="font-bold text-gray-800 text-base">{job ? 'עריכת משרה' : 'הוספת משרה חדשה'}</h2>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-xl border-2 border-gray-200 text-gray-400 hover:bg-gray-50 cursor-pointer transition-all"><i className="ri-close-line text-base"></i></button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className={labelClass}>כותרת המשרה *</label>
            <input type="text" name="title" value={form.title} onChange={handleChange} required placeholder="שם התפקיד..." className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>שם החברה</label>
            <input type="text" name="company" value={form.company} onChange={handleChange} placeholder="שם החברה..." className={inputClass} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={labelClass}>מיקום</label>
              <input type="text" name="location" value={form.location} onChange={handleChange} placeholder="עיר..." className={inputClass} />
            </div>
            <div>
              <label className={labelClass}>סוג משרה</label>
              <select name="type" value={form.type} onChange={handleChange} className={inputClass}>
                <option value="full-time">משרה מלאה</option>
                <option value="part-time">משרה חלקית</option>
                <option value="freelance">פרילנס</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={labelClass}>תאריך פרסום</label>
              <input type="date" name="posted_date" value={form.posted_date} onChange={handleChange} className={inputClass} />
            </div>
            <div>
              <label className={labelClass}>סטטוס</label>
              <select name="status" value={form.status} onChange={handleChange} className={inputClass}>
                <option value="open">פתוח</option>
                <option value="closed">סגור</option>
              </select>
            </div>
          </div>
          <div>
            <label className={labelClass}>תיאור המשרה</label>
            <textarea name="description" value={form.description} onChange={handleChange} rows={3} placeholder="תיאור קצר של המשרה..." className={`${inputClass} resize-none`} maxLength={500} />
          </div>
          <div>
            <label className={labelClass}>דרישות (מופרדות בפסיק)</label>
            <input type="text" value={form.requirements.join(', ')} onChange={(e) => setForm((f) => ({ ...f, requirements: e.target.value.split(',').map((r) => r.trim()).filter(Boolean) }))}
              placeholder="React, Node.js, 3+ שנות ניסיון..." className={inputClass} />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="submit" className="flex-1 py-2.5 rounded-xl bg-rose-400 text-white text-sm font-bold hover:bg-rose-500 transition-all cursor-pointer whitespace-nowrap">{job ? 'שמור שינויים' : 'הוסף משרה'}</button>
            <button type="button" onClick={onClose} className="px-5 py-2.5 rounded-xl border-2 border-gray-200 text-gray-500 text-sm font-semibold hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap">ביטול</button>
          </div>
        </form>
      </div>
    </div>
  );
}
